import React from 'react';
import { Typography, Box } from '@mui/material';

const CustomTitleWithBlueBackground = ({
  text,
  variant = 'h5',
  gutterBottom = true,
  parentSxProps = {},
  sx = {},
  ...props
}) => {
  const hasMultipleLines = text.includes('\n');

  // Split the text into lines if there are newline characters, otherwise treat it as a single line
  // The caller has to make sure that they had '\n' characters to split the text accordingly.
  const lines = hasMultipleLines ? text.split('\n') : [text];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: hasMultipleLines ? '4px' : '0',
        ...parentSxProps,
      }}
      {...props}
    >
      {lines.map((line, index) => (
        <Box
          key={index}
          sx={{
            width: 'fit-content',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            background: 'var(--blue-500, #0054FC)',
          }}
        >
          <Typography
            variant={variant}
            gutterBottom={gutterBottom && !hasMultipleLines}
            sx={{
              color: 'var(--M3-white, #FFF)',
              fontSize: '24px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '32px',
              ...sx,
            }}
          >
            {line}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CustomTitleWithBlueBackground;
